import InviteTokenHandlerContainer from './InviteTokenHandlerContainer';

export default InviteTokenHandlerContainer;
